module.exports = __webpack_public_path__ + "img/DealerIcons-EV-Off.11e87bb.jpg";